import React from "react";
import styled from "styled-components";

// components
import ImageTicker from "./ImageTicker";

// assets
import TGA from "assets/img/partners/TGA.png";
import TTBC from "assets/img/partners/ttbc.png";
import NEOS_DELTA from "assets/img/partners/neos_delta.png";
import AGE_INC from "assets/img/partners/ageinc.png";
import LFAI from "assets/img/partners/lfai.png";
import RECREATE from "assets/img/partners/recreate.png";
import DYA from "assets/img/partners/dya.jpg";

const images = [
  TGA,
  TTBC,
  NEOS_DELTA,
  AGE_INC,
  RECREATE,
  LFAI,
  DYA,
  TGA,
  TTBC,
  NEOS_DELTA,
  AGE_INC,
  RECREATE,
  LFAI,
  DYA,
  TGA,
  TTBC,
  NEOS_DELTA,
  AGE_INC,
  RECREATE,
  LFAI,
  DYA,
  TGA,
  TTBC,
  NEOS_DELTA,
  AGE_INC,
  RECREATE,
  LFAI,
  DYA,
  TGA,
  TTBC,
  NEOS_DELTA,
  AGE_INC,
  RECREATE,
  LFAI,
  DYA,
  TGA,
  TTBC,
  NEOS_DELTA,
  AGE_INC,
  RECREATE,
  LFAI,
  DYA,
];

export default function Partners() {
  return (
    <>
      <Wrapper>
        {/* <Heading3>
          Age Inclusive{" "}
          <span style={{ color: "var(--Lavender, #A6BCFF)" }}>Companies</span>{" "}
          and{" "}
          <span style={{ color: "var(--Lavender, #A6BCFF)" }}>Partners</span>
        </Heading3> */}
        <TickerWrapper>
          <ImageTicker images={images} />
        </TickerWrapper>
      </Wrapper>
    </>
  );
}

const TickerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: calc(5vw + 10px);
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

const Wrapper = styled.section`
  padding-top: 26px;
  padding-bottom: 24px;
  background-color:#fff;
  # background-color: #1d1f27;
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
